<template>
  <div class="bg-surface rounded-md">
    <Icon :name="contentIcon" :size="props.size" />
  </div>
</template>

<script setup lang="ts">
import { Icon, IconName, IconSize } from '@exfluential/ui';
import { computed } from 'vue';
import { ContentType } from '~/api/contents';

type Props = {
  contentType: ContentType;
  size?: IconSize;
};
const props = withDefaults(defineProps<Props>(), {
  size: IconSize.LG,
});

const contentTypeIconMap = {
  [ContentType.RESOURCE]: IconName.CONTENT_RESOURCE,
  [ContentType.SOCIALS]: IconName.CONTENT_SOCIALS,
  [ContentType.FILES]: IconName.CONTENT_FILES,
  [ContentType.SCORM_COURSE]: IconName.CLOUD,
};
const contentIcon = computed(() => {
  return contentTypeIconMap[props.contentType];
});
</script>
